import { combineReducers } from 'redux';
import storage from './storage';
import powerStatus from './powerStatus';

export default combineReducers({
  storage,
  powerStatus,
});



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/redux/reducers/hosts/index.js